module.exports = __webpack_public_path__ + "img/banner2_5.e2f93644.png";